import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { ContractForm } from './ContractForm'
import { ActionsType } from './types'

const formName = 'add-edit-contract-form'

type Props = { contract?: ActionsType['contract'] } & Omit<
  ActionsType,
  'contract'
>

export const AddEditContract = ({ contract, ...props }: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      width={800}
      maskClosable={false}
      title={t('lead.contracts')}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.save')}
      okButtonProps={{
        htmlType: 'submit',
        form: formName
      }}
      {...props}
    >
      <ContractForm
        id={contract?.id}
        formName={formName}
        closeModal={props.onCancel}
      />
    </Modal>
  )
}
